import { AcrossSignatureType } from '@/types'

export const acrossOptimexAuth = {
  OptimexAuth: [{ name: 'infoHash', type: 'bytes32' }],
}

export const acrossUserAuth = {
  UserAuth: [{ name: 'infoHash', type: 'bytes32' }],
}

export const acrossAgentAuth = {
  BridgeFromOptimex: [
    { name: 'tradeId', type: 'bytes32' },
    { name: 'infoHash', type: 'bytes32' },
  ],
}

export const fallbackTransfer = {
  FallbackTransfer: [
    { name: 'tradeId', type: 'bytes32' },
    { name: 'infoHash', type: 'bytes32' },
  ],
}

const acrossRefundRequest = {
  RequestRefund: [
    { name: 'tradeId', type: 'bytes32' },
    { name: 'infoHash', type: 'bytes32' },
  ],
}

const acrossRefundedConfirmation = {
  ConfirmRefunded: [
    { name: 'requestId', type: 'bytes32' },
    { name: 'infoHash', type: 'bytes32' },
  ],
}

const acrossRejectRefund = {
  RejectRefund: [
    { name: 'requestId', type: 'bytes32' },
    { name: 'infoHash', type: 'bytes32' },
  ],
}
export const getSignatureType = (type: AcrossSignatureType): any => {
  //  used for Across Bridge contracts
  if (type === AcrossSignatureType.AcrossOptimexAuth) return acrossOptimexAuth
  else if (type === AcrossSignatureType.AcrossUserAuth) return acrossUserAuth
  else if (type === AcrossSignatureType.AcrossAgentAuth) return acrossAgentAuth
  else if (type === AcrossSignatureType.FallbackTransfer) return fallbackTransfer
  //  used for AcrossRefund contract on Optimex L2 Protocol
  else if (type === AcrossSignatureType.AcrossL2RequestRefund) return acrossRefundRequest
  else if (type === AcrossSignatureType.AcrossL2ConfirmRefund) return acrossRefundedConfirmation
  else if (type === AcrossSignatureType.AcrossL2RejectRefund) return acrossRejectRefund
  else throw new Error('Invalid signature type!')
}
